import api from "@/requests";

export const getSwitchers = () =>
  api.get(`api/v1/Myred/GetRedConfig`, {
    showLoader: false,
    showAlert: false,
  });
  export const addShortLog = (payload) =>
  api.post(`api/v1/MyBank/AjaxLoggerHelper`, payload, {
    showLoader: false,
    showAlert: false,
  });